import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, NumberToPersianLetters, ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AddEditTuitionPaymentModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    id: number,
    isEdit: boolean,
    price: number,
    paidDate: string,
    payMethod: "online" | "cash" | "old",
    studentId:string,
    totalLeft:number,
}) => {
    const [price, setPrice] = useState('0');
    const [time, setTime] = useState({
        time: [0, 0, 0],
        date: '2024-01-01',
    });
    const [payMethod, setPayMethod] = useState('cash' as "online" | "cash" | "old");
    const [err, setErr] = useState({
        price: false,
    });
    const ids = {
        price: useId(),
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        const _price = props.price;
        const _date = props.paidDate;
        const _method = props.payMethod;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            if (isEdit) {
                let d = _date.split(' ');
                let t = d[1].split(':');
                setTime({
                    time: [parseInt(t[0]), parseInt(t[1]),parseInt(t[2])],
                    date: d[0],
                });
                setPrice(_price.toString());
                setPayMethod(_method);
            } else {
                let todayIso = new Date().toISOString().split('T')[0];
                setTime({
                    time: [0, 0,0],
                    date: todayIso,
                });
                setPrice('');
                setPayMethod('cash');
            }
            setErr({
                price: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active, props.isEdit]);
    const saveChanges = () => {
        const isEdit = props.isEdit;
        const id = props.id;
        const _price = price;
        const paidAt = {...time};
        const studentId = props.studentId;
        const method = payMethod;
        const totalLeft = props.totalLeft;
        const firstPrice = isEdit ? props.price : 0;
        if(_price === ''){
            setErr({
                price: true,
            });
            return;
        }
        const priceInt = parseInt(_price);
        if(priceInt > (totalLeft + firstPrice)){
            ShowSnackbar('مبلغ پرداختی بیشتر از باقیمانده شهریه است.','باشه',5000);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/payments/' + (isEdit ? 'edit':'add'),
            {
                studentId:studentId,
                id:id.toString(),
                price:_price,
                paidAt:`${paidAt.date} ${paidAt.time[0]}:${paidAt.time[1]}:${paidAt.time[2]}`,
                payMethod:method,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    isEdit ? 'ویرایش پرداخت انجام شد.' : 'پرداخت جدید ثبت شد.',
                    'باشه',
                    5000
                );
                props.closeHandler();
                props.onDone();
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-big" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.isEdit ? 'ویرایش پرداخت' : 'پرداخت جدید'}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="add-student">
                            <div className="row no-gutters align-items-end">
                                <div className="col-lg-6">
                                    <label htmlFor={ids.price}>هزینه پرداختی:</label>
                                    <input
                                        type="number"
                                        min={0}
                                        className={"form-control" + (err.price ? ' is-invalid' : '')}
                                        value={price}
                                        onChange={e => {
                                            const t = e.currentTarget.value;
                                            setPrice(ToxicDigitsFixToEnglish(t));
                                            setErr({
                                                price: false,
                                            });
                                        }}
                                    />
                                    {
                                        price !== '' ?
                                            <span style={{
                                                display: 'block',
                                                margin: '5px 0 0 0',
                                                fontWeight: 400,
                                                color: '#0a53be'
                                            }}>
                                       {NumberToPersianLetters(parseInt(price)) + " تومان"}
                                   </span> : null
                                    }
                                    {
                                        !props.isEdit ?
                                            <span style={{
                                                display:'block',
                                                color:'#444',
                                                fontWeight:400,
                                                margin:'5px 0 0 0',
                                                fontSize:14,
                                            }}>باقیمانده کل شهریه قابل پرداخت: {CurrencyFormat(props.totalLeft) +" تومان"}</span> : null
                                    }
                                    <div className={"invalid-feedback " + (err.price ? 'd-block' : 'd-none')}>
                                        لطفا مبلغ را بصورت صحیح وارد نمایید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label>تاریخ پرداخت:</label>
                                    <TimePicker
                                        lang={'fa'}
                                        hour={time.time[0]}
                                        minute={time.time[1]}
                                        setState={(h: number, m: number) => setTime(v => {
                                            let x = {...v};
                                            x.time[0] = h;
                                            x.time[1] = m;
                                            return x;
                                        })}
                                        title={''}
                                        locked={false}
                                        onSave={() => {
                                        }}
                                        date={time.date}  // gregorian
                                        setDate={(d: string) => setTime(v => {
                                            let x = {...v};
                                            x.date = d.split(" ")[0];
                                            return x;
                                        })}
                                        hasDate={true}
                                    />
                                    <div style={{height: 20}}/>
                                    <label>نحوه پرداخت:</label>
                                    {/*<button className={"techaran-radio-box" + (payMethod === 'online' ? ' active' : '')}*/}
                                    {/*        onClick={() => setPayMethod('online')}>*/}
                                    {/*    <div><i/></div>*/}
                                    {/*    <span>آنلاین</span>*/}
                                    {/*</button>*/}
                                    <button className={"techaran-radio-box" + (payMethod === 'cash' ? ' active' : '')}
                                            onClick={() => setPayMethod('cash')}>
                                        <div><i/></div>
                                        <span>نقدی</span>
                                    </button>
                                    {/*<button className={"techaran-radio-box" + (payMethod === 'old' ? ' active' : '')}*/}
                                    {/*        onClick={() => setPayMethod('old')}>*/}
                                    {/*    <div><i/></div>*/}
                                    {/*    <span>سامانه قدیم</span>*/}
                                    {/*</button>*/}
                                    <div style={{height: 120}}/>
                                </div>
                                <div className="col-lg-6">
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{gap: 20, marginTop: 0}}>
                                        <button className="cancel-button" onClick={props.closeHandler}>
                                            <b>انصراف</b>
                                        </button>
                                        <button className="btn-pay" onClick={saveChanges}>
                                            <b>ذخیره تغییرات</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};